import { connect } from 'react-redux';

import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectIaLogic, selectSchedulesStartDate } from 'selectors/general';

import SchedulesBoard from './SchedulesBoard';

const mapStateToProps = (state, ownProps) => {
  const { venueId } = selectActiveVenue(state, ownProps);
  const { featureIsSupported } = selectIaLogic(state, IA_KEY.MANAGE_CLASS_SCHEDULE, venueId);

  return {
    featureIsSupported,
    startDate: selectSchedulesStartDate(state),
    venueId,
  };
};

export default connect(mapStateToProps)(SchedulesBoard);
